import {
   ADD_AREA_SUCCESS,
   ADD_AREA_FAIL,
   DELETE_CUSTOM_PLANT_SUCCESS,
   DELETE_CUSTOM_PLANT_FAIL,
   DELETE_AREA_SUCCESS,
   DELETE_AREA_FAIL,
   UPDATE_AREA_SUCCESS,
   UPDATE_AREA_FAIL,
   UPDATE_CUSTOM_PLANT_SUCCESS,
   UPDATE_CUSTOM_PLANT_FAIL,
   SAVE_CUSTOM_PLANT_SUCCESS,
   SAVE_CUSTOM_PLANT_FAIL,
   GET_AREAS_SUCCESS,
   GET_AREAS_FAIL,
   GET_CUSTOM_PLANTS_SUCCESS,
   GET_CUSTOM_PLANTS_FAIL,
   SEARCH_GUILD_SUCCESS,
   SEARCH_GUILD_FAILURE,
   GET_OBJECTIVES_SUCCESS,
   GET_OBJECTIVES_FAIL,
   GET_USER_GUILDS_SUCCESS, GET_USER_GUILDS_FAIL,
   CREATE_USER_GUILD_SUCCESS, CREATE_USER_GUILD_FAIL,
   UPDATE_USER_GUILD_SUCCESS, UPDATE_USER_GUILD_FAIL,
   DELETE_USER_GUILD_SUCCESS, DELETE_USER_GUILD_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  areas: [],
  objectives: [],
  error: {},
  plants: [],
  customplants: [],
  userGuilds: [],
}

const Goals  = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_AREAS_SUCCESS:
      return {
        ...state,
        areas: action.payload,
      }

    case GET_AREAS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CUSTOM_PLANTS_SUCCESS:
      return {
        ...state,
        customplants: action.payload,
      }

    case GET_CUSTOM_PLANTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_AREA_SUCCESS:
      return {
	...state,
	areas: [...state.areas, action.payload],
    }

    case ADD_AREA_FAIL:
      return {
	...state,
	error: action.payload,
    }

    case SEARCH_GUILD_SUCCESS:
      return {
        ...state,
        plants: action.payload,
      }

    case SEARCH_GUILD_FAILURE:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_AREA_SUCCESS:
      return {
        ...state,
        areas: state.areas.filter(
          area => area.id.toString() !== action.payload.toString()
        ),
      }

    case DELETE_AREA_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_CUSTOM_PLANT_SUCCESS:
      console.log("deletedplant")
      return {
        ...state,
        customplants: state.customplants.filter(
          customplant => customplant.id.toString() !== action.payload
        ),
      }

    case DELETE_CUSTOM_PLANT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_AREA_SUCCESS:
      return {
        ...state,
        areas: state.areas.map((area) =>
            area.id === action.payload.id ? action.payload : area
      ),
    }

    case UPDATE_AREA_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_CUSTOM_PLANT_SUCCESS:
      console.log("updatecustom")
      return {
        ...state,
        customplants: state.customplants.map(customplant =>
          customplant.id.toString() === action.payload.id.toString()
            ? { ...customplant, ...action.payload }
            : customplant
        ),
      }

    case UPDATE_CUSTOM_PLANT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SAVE_CUSTOM_PLANT_SUCCESS:
      return {
	  ...state,
	  customplants: [...state.customplants, action.payload],
      }

    case SAVE_CUSTOM_PLANT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_OBJECTIVES_SUCCESS:
      return {
	...state,
        objectives: action.payload,
      }

    case GET_OBJECTIVES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_GUILDS_SUCCESS:
      return { ...state, userGuilds: action.payload }
    case GET_USER_GUILDS_FAIL:
      return { ...state, error: action.payload }

    case CREATE_USER_GUILD_SUCCESS:
      return { ...state, userGuilds: [...state.userGuilds, action.payload] }
    case CREATE_USER_GUILD_FAIL:
      return { ...state, error: action.payload }

    case UPDATE_USER_GUILD_SUCCESS:
      return {
        ...state,
        userGuilds: state.userGuilds.map(g =>
          g.id === action.payload.id ? action.payload : g
        ),
      }
    case UPDATE_USER_GUILD_FAIL:
      return { ...state, error: action.payload }

    case DELETE_USER_GUILD_SUCCESS:
      return {
        ...state,
        userGuilds: state.userGuilds.filter(g => g.id !== action.payload),
      }
    case DELETE_USER_GUILD_FAIL:
      return { ...state, error: action.payload }

    default:
      return state
  }
}

export default Goals 
